var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFbBbDefault(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1467 12.5733C24.1467 5.90541 18.7413 0.5 12.0733 0.5C5.40541 0.5 0 5.90541 0 12.5733C0 18.5994 4.41502 23.5943 10.1869 24.5V16.0633H7.12138V12.5733H10.1869V9.91343C10.1869 6.88755 11.9894 5.21615 14.7472 5.21615C16.0677 5.21615 17.4497 5.45195 17.4497 5.45195V8.42313H15.9274C14.4276 8.42313 13.9598 9.35386 13.9598 10.3096V12.5733H17.3083L16.773 16.0633H13.9598V24.5C19.7317 23.5943 24.1467 18.5994 24.1467 12.5733Z",
    fill: "#123051"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbBbDefault);
export default __webpack_public_path__ + "static/media/FbBBDefault.19499ae3a7875bd0ea7860264ac205c8.svg";
export { ForwardRef as ReactComponent };